import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBrushDrawIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 2,
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M2 18h20",
		opacity: .25
	}), /* @__PURE__ */ _jsx("path", {
		strokeWidth: 2.2,
		d: "M2 18C4 18 6 7 12 7s8 11 10 11"
	})]
});
export default SvgBrushDrawIcon;
